import api, { handleResponse, handleError } from './api';

/**
 * Global search (top bar). One endpoint returns
 * `{ events, people, clubs }`, each `{ items, total }`, capped at 5 per
 * category server-side. An empty query returns the browse payload.
 * docs/plans/2026-08-handoff-layout/08-search.md
 */
const searchService = {
  async search({ q = '', lat = null, lng = null } = {}) {
    try {
      const params = new URLSearchParams();
      if (q) params.set('q', q);
      if (lat != null && lng != null) { params.set('lat', String(lat)); params.set('lng', String(lng)); }
      return handleResponse(await api.get(`/search${params.toString() ? `?${params}` : ''}`));
    } catch (e) {
      return handleError(e);
    }
  },

  // Paged per-category results for the full "see all" list (infinite scroll).
  async searchPeople({ q = '', skip = 0, take = 20 } = {}) {
    try {
      const params = new URLSearchParams();
      if (q) params.set('q', q);
      params.set('skip', String(skip));
      params.set('take', String(take));
      return handleResponse(await api.get(`/search/people?${params}`));
    } catch (e) {
      return handleError(e);
    }
  },

  // Paged event results — the signal composer's LINK AN EVENT picker.
  async searchEvents({ q = '', skip = 0, take = 20 } = {}) {
    try {
      const params = new URLSearchParams();
      if (q) params.set('q', q);
      params.set('skip', String(skip));
      params.set('take', String(take));
      return handleResponse(await api.get(`/search/events?${params}`));
    } catch (e) {
      return handleError(e);
    }
  },

  // One event as a search row, for a picker that already holds the id. Fails
  // (404) when the event isn't one a signal may link to.
  async getEvent(id) {
    try {
      return handleResponse(await api.get(`/search/events/${id}`));
    } catch (e) {
      return handleError(e);
    }
  },

  async searchClubs({ q = '', skip = 0, take = 20 } = {}) {
    try {
      const params = new URLSearchParams();
      if (q) params.set('q', q);
      params.set('skip', String(skip));
      params.set('take', String(take));
      return handleResponse(await api.get(`/search/clubs?${params}`));
    } catch (e) {
      return handleError(e);
    }
  },
};

export default searchService;
